import {
  hasTrailer,
  isTrailerPreviewTypeEnabled,
  isPlayable,
} from '@wix/wix-vod-shared/common';

import i18n from '../i18n';
import { isFreeVideo } from './index';

const getPlayButtonText = (videoItem) => {
  if (!isPlayable(videoItem)) {
    return null;
  }

  if (isFreeVideo(videoItem)) {
    return i18n.t('cover.play-video');
  }

  if (hasTrailer(videoItem) && isTrailerPreviewTypeEnabled(videoItem)) {
    return i18n.t('cover.watch-trailer');
  }

  return i18n.t('cover.watch-preview');
};

export default getPlayButtonText;
